<template>
  <FormulateInput
    v-bind="{ ...$props, ...$attrs }"
    help-position="after"
    :dropzone-options="dropzoneOptions"
  />
</template>

<script>
export default {
  name: 'UploadField',
  props: {
    type: {
      type: String,
      default: 'dropzone',
    },
    name: {
      type: String,
      required: true,
    },
    dropzoneOptions: {
      type: Object,
      default: () => ({}),
    },
    validation: {
      type: [String, Array],
      default: 'required',
    },
    validationMessages: {
      type: Object,
      default: () => ({ required: 'Dieses Feld ist ein Pflichtfeld' }),
    },
    help: {
      type: String,
      default() {
        return this.helpText;
      },
    },
  },
  computed: {
    helpText() {
      if (this.dropzoneOptions.maxFilesize) {
        return `Bitte lade ein PDF-Dokument hoch (max. ${this.dropzoneOptions.maxFilesize} MB Dateigröße).`;
      }

      return undefined;
    },
  },
};
</script>
